<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M15 2V0H17V2H20V20H0V2H3V0H5V2H15ZM2 18V9H18V18H2ZM7 13H4V16H7V13Z"
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
